import React from 'react';

import type { TabOption } from '@/components/chariot-ui';
import type {
  MainTabKey,
  POEContent,
  SectionContent,
} from '@/sections/poe/types/poe.types';
import { logger } from '@/utils/logger';

export function renderErrorFallback(
  poeData: POEContent,
  sections: Record<string, SectionContent>,
  tempTabs: Record<MainTabKey, TabOption[]>,
  mainTabKeys: MainTabKey[]
): void {
  logger.error({
    source: 'wiz',
    riskKey: '',
    processor: 'processWizDataSource',
    errorType: 'parse_failure',
    timestamp: Date.now(),
  });

  sections['wiz_error'] = (
    <div className="border-error-light bg-error-selected rounded border p-4">
      <h4 className="text-error mb-2 font-semibold">
        Wiz Evidence Processing Error
      </h4>
      <p className="text-error text-sm">Unable to process Wiz evidence data.</p>
      {import.meta.env.DEV && (
        <p
          className="text-chariot-text-tertiary mt-2 text-xs"
          data-testid="wiz-dev-info"
        >
          Payload type: {typeof poeData}, size:{' '}
          {typeof poeData === 'string' ? (poeData as string).length : 'N/A'}
        </p>
      )}
    </div>
  );
  if (mainTabKeys.includes('INFORMATION')) {
    tempTabs['INFORMATION'].push({
      label: 'Processing Error',
      value: 'wiz_error',
    });
  }
}
